//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import ArticleContent from '../CommonComponents/ArticleContent.vue';
import TopicSelector from '../CommonComponents/TopicSelector.vue';
import SuggestedArticles from '../CommonComponents/SuggestedArticles.vue';
import TableOfContentListDesktop from './TableOfContentListDesktop.vue';
import { slugify } from '~/services/utilityFunctions.js';
import analyticEvents, { ANALYTIC_SOURCE_MODULES } from '~/services/analyticEvents';
import { ARTICLE_TYPE } from '~/static/constants.js';
import { ROUTES } from '~/constants/pageRoutes';
import { BLOG_TOPICS } from '~/constants/blogConstants';
import { EXAM_TYPES } from '~/constants/generalConstants';
import greDiagnosticTestMixin from '~/mixins/greDiagnosticTestMixin';
import { ACQUISITION_SOURCE_CTA } from '~/constants/authFlows';

const ActivityNudge = () => import('../../ReusableComponents/ActivityNudge.vue');

export default {
    name: 'GuideDesktop',
    components: {
        ArticleContent,
        TopicSelector,
        ActivityNudge,
        TableOfContentListDesktop,
        SuggestedArticles
    },
    mixins: [greDiagnosticTestMixin],
    inject: ['blogTopic'],
    props: {
        articleMetadata: {
            type: Object,
            default: () => {}
        },
        articleContent: {
            type: String,
            default: ''
        },
        isArticleTruncated: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            selectedGuide: {},
            bannerHeading: '',
            bannerSubheading: '',
            bannerCtaText: '',
            bannerCtaFunction: () => {},
            currentActiveSection: '',
            // Scroll Event Flags
            dynamicClass: 'sticky',
            nativeStyle: {
                top: '-16px'
            },
            scrollUpCount: 0,
            intersectionObserver: null,
            scrollDownCount: 0,
            // documentScrollBehaviour: null,
            sideBarScrollBehaviour: null,
            reachedTop: false,
            ARTICLE_TYPE,
            BLOG_TOPICS
        };
    },
    computed: {
        ...mapGetters({
            isAuthenticated: 'auth/isAuthenticated',
            isPremiumUser: 'auth/isPremiumUser',
            hasGivenFullDiagnostic: 'auth/hasGivenFullDiagnostic',
            isDashboardSetup: 'auth/isDashboardSetup',
            quickDiagnosticData: 'testSets/quickDiagnosticData',
            fullDiagnosticData: 'testSets/fullDiagnosticData',
            testType: 'auth/testType'
        })
    },
    mounted() {
        window.scrollTo(0, 0);
        // Setup Guide Data
        this.selectedGuide = this.articleMetadata;
        this.setTableOfContentSectionObserver();
        this.startObserving();
        // Buggy
        // this.attachDocumentEvents();
        this.setBannerData();
    },
    beforeDestroy() {
        window.removeEventListener('wheel', this.scrollListener);
        if (this.intersectionObserver !== null) {
            this.intersectionObserver.disconnect();
            this.intersectionObserver = null;
        }
    },
    methods: {
        setTableOfContentSectionObserver() {
            this.intersectionObserver = new IntersectionObserver(
                (entries) => {
                    const element = entries[0];
                    this.sideBarScrollBehaviour = document
                        .getElementById('tocSidebar')
                        .getBoundingClientRect().top;
                    if (element.target.id === 'testNudge' && element.isIntersecting) {
                        this.scrollUpCount = 0;
                        this.reachedTop = false;
                        const currentTop = document
                            .getElementById('tocSidebar')
                            .getBoundingClientRect().top;
                        this.dynamicClass = 'sticky TOC';
                        this.nativeStyle = {
                            top: currentTop + 'px'
                        };
                    } else if (
                        element.target.id === 'tocTextPlaceholder' &&
                        element.isIntersecting
                    ) {
                        this.scrollDownCount = 0;
                        this.reachedTop = true;
                        this.dynamicClass = 'sticky testNudge';
                        this.nativeStyle = {
                            top: '56px',
                            'margin-top': '0px'
                        };
                    } else {
                        this.scrollDownCount = 0;
                        this.reachedTop = true;
                        this.dynamicClass = 'sticky testNudge';
                        this.nativeStyle = {
                            top: '-250px',
                            'margin-top': '0px'
                        };
                    }
                },
                {
                    threshold: [1],
                    rootMargin: '-100px 0px 0px 0px'
                }
            );
        },
        // attachDocumentEvents() {
        //     document.addEventListener('wheel', this.scrollListener);
        // },
        startObserving() {
            for (const key in this.$refs) {
                const reference = this.$refs[key];
                this.intersectionObserver.observe(reference || reference.$el);
            }
        },
        // scrollListener(event) {
        //     this.documentScrollBehaviour = this.getScrollAmount();
        //     // Manage a edge case to check if sidebar is already in view port completely, if so, do not scroll.
        //     const tocTable = this.$refs.testNudge;
        //     if (this.isInViewport(tocTable)) return;
        //     if (event.deltaY < 0 && this.scrollUpCount === 0 && !this.reachedTop) {
        //         this.scrollUpCount = 1;
        //         this.dynamicClass = 'relative scroll-up';
        //         this.nativeStyle = {
        //             top: this.documentScrollBehaviour + this.sideBarScrollBehaviour - 56 + 'px'
        //         };
        //     } else if (event.deltaY > 0 && this.scrollDownCount === 0 && this.reachedTop) {
        //         this.scrollDownCount = 1;
        //         this.dynamicClass = 'relative scroll-down';
        //         this.nativeStyle = {
        //             top:
        //                 this.documentScrollBehaviour > 56
        //                     ? this.documentScrollBehaviour + 'px'
        //                     : '0px'
        //         };
        //     }
        // },
        // getScrollAmount() {
        //     const doc = document.documentElement;
        //     const st = 'scrollTop';
        //     return doc[st];
        // },
        setBannerData() {
            if (
                this.isAuthenticated &&
                this.blogTopic === BLOG_TOPICS.GRE &&
                this.testType === EXAM_TYPES.GMAT
            ) {
                return;
            }
            if (this.blogTopic === BLOG_TOPICS.IELTS) {
                this.bannerHeading = 'Fast-Track Your IELTS Prep';
                this.bannerSubheading = 'Get step-by-step guidance for IELTS success';
                this.bannerCtaText = 'Talk to an Expert';
                this.bannerCtaFunction = () => {
                    this.handleGuideHookClickEvent();
                    window.open(ROUTES.IELTS_TOEFL_DEMO, '_blank');
                };
                return;
            }
            if (this.blogTopic === BLOG_TOPICS.TOEFL) {
                this.bannerHeading = 'Your TOEFL Success Starts Here';
                this.bannerSubheading = 'Get expert guidance for a top TOEFL score today';
                this.bannerCtaText = 'Book a Free Call';
                this.bannerCtaFunction = () => {
                    this.handleGuideHookClickEvent();
                    window.open(ROUTES.IELTS_TOEFL_DEMO, '_blank');
                };
                return;
            }
            if (this.blogTopic === BLOG_TOPICS.GMAT) {
                if (!this.isAuthenticated) {
                    this.bannerHeading = 'Get GMAT Prepared with Yocket Prep';
                    this.bannerSubheading = 'Prepare smarter, not harder, with Yocket Prep';
                    this.bannerCtaText = 'Signup on Yocket Prep Now';
                    this.bannerCtaFunction = () => {
                        this.$store.commit(
                            'auth/setSignupCtaSource',
                            this.articleMetadata.type === ARTICLE_TYPE.GUIDE
                                ? ACQUISITION_SOURCE_CTA.gmat_guide_signup
                                : ACQUISITION_SOURCE_CTA.gmat_blog_signup
                        );
                        this.handleGuideHookClickEvent();
                        this.$router.push({
                            path: ROUTES.LOGIN,
                            query: { tab: 'signup' }
                        });
                    };
                } else {
                    this.bannerHeading = 'Join Live GMAT Classes Now!';
                    this.bannerSubheading = 'Live expert-led GMAT prep—study smarter, score higher';
                    this.bannerCtaText = 'Book A demo';
                    this.bannerCtaFunction = () => {
                        this.handleGuideHookClickEvent();
                        window.open(ROUTES.GMAT_BOOK_DEMO, '_blank');
                    };
                }
                return;
            }

            // If the blog is GRE and user is not logged in
            if (!this.isAuthenticated && this.blogTopic === BLOG_TOPICS.GRE) {
                this.bannerHeading = 'How Ready Are You for GRE?';
                this.bannerSubheading = 'Take a free GRE test and get a performance report!';
                this.bannerCtaText = 'Start Free Mock Test';
                this.bannerCtaFunction = () => {
                    this.takeGreDiagnosticTest(ANALYTIC_SOURCE_MODULES.BLOGS_GUIDES);
                    this.handleGuideHookClickEvent();
                };

                return;
            }

            // LOGGED IN USERS here onwards

            if (this.hasGivenFullDiagnostic) {
                if (this.isDashboardSetup) {
                    this.bannerHeading = 'Put the pedal to the metal!';
                    this.bannerSubheading =
                        'Gear up and start practising to improve on your weaknesses and hone your strengths with these personalized practice tests!';
                    this.bannerCtaText = 'Take Practice Tests';

                    this.bannerCtaFunction = () => {
                        this.handleGuideHookClickEvent();
                        this.$router.push(ROUTES.DASHBOARD);
                    };
                } else {
                    this.bannerHeading = 'Put the pedal to the metal!';
                    this.bannerSubheading =
                        'Gear up and start practising to improve on your weaknesses and hone your strengths with these personalized practice tests!';
                    this.bannerCtaText = 'Setup Priority Dashboard';

                    this.bannerCtaFunction = () => {
                        this.handleGuideHookClickEvent();
                        this.$router.push(ROUTES.DASHBOARD);
                    };
                }
            }
            // QD/Default dasboard is setup
            else if (this.isDashboardSetup) {
                if (!this.isPremiumUser) {
                    // Setup QD but is not Premium
                    this.bannerHeading = 'Unlock full set of Practice Tests!';
                    this.bannerSubheading =
                        'Level up with GRE® mocks, instant score reports, detailed solutions, in-depth analysis and more.';
                    this.bannerCtaText = 'Upgrade to PREP+';

                    this.bannerCtaFunction = () => {
                        this.handleGuideHookClickEvent();
                        const trackingEvent = {
                            event: analyticEvents.prep_upgrade_to_plus,
                            data: {
                                source: 'upgrade_banner_gre_guides'
                            }
                        };
                        this.$store.dispatch('analytics/trackEvent', trackingEvent);
                        this.$router.push(ROUTES.PRICING);
                    };
                } else {
                    this.bannerHeading = 'Know your game!';
                    this.bannerSubheading =
                        'Focus on your strengths and tackle your weaknesses with the help of a detailed analysis from this full diagnostic test!';
                    this.bannerCtaText = 'Take Full Diagnostic Test';

                    this.bannerCtaFunction = async () => {
                        this.handleGuideHookClickEvent();

                        if (!this.fullDiagnosticData) {
                            // If the QD data is not available, try to fetch again and contiue, if it still fails then return
                            const response = await this.$store.dispatch(
                                'testSets/fetchDiagnosticTestData',
                                { diagnosticTestType: 'FD', testType: this.testType }
                            );
                            const trackingEvent = {
                                event: analyticEvents.prep_fulldiag_start_test,
                                data: {
                                    source: 'gre_guide'
                                }
                            };
                            this.$store.dispatch('analytics/trackEvent', trackingEvent);
                            if (!response.state) return;
                        }
                        // this.$emit('startDiagnosticTest');
                        // Set the instructions for the test to begin that is QD
                        this.$store.commit('testSets/setActiveTest', this.fullDiagnosticData);
                        this.$store.commit('testSets/setShowInstructions', true);
                    };
                }
            }
            // QD taken but Dashboard not set up
            else {
                this.bannerHeading = 'A dashboard for access!';
                this.bannerSubheading = 'Set up the prep dashboard to keep your targets in sight.';
                this.bannerCtaText = 'Setup Dashboard';

                this.bannerCtaFunction = () => {
                    this.handleGuideHookClickEvent();
                    this.$router.push(ROUTES.DASHBOARD);
                };
            }
        },
        handleGuideHookClickEvent() {
            this.$store.dispatch('analytics/trackEvent', {
                event: analyticEvents.guide_hook_clicked,
                data: {
                    guide_name: this.blogTopic.toUpperCase(),
                    blog_url: `${window.location.origin}${this.$route.path}`
                }
            });
        },
        setSelectedTopic($event) {
            const matchedToc = this.selectedGuide.tableOfContentList.filter(
                (ele) => slugify(ele) === $event
            )[0];
            if (matchedToc) this.currentActiveSection = matchedToc;
        },
        isInViewport(el) {
            if (el) {
                const rect = el.getBoundingClientRect();
                return (
                    rect.top >= 0 &&
                    rect.left >= 0 &&
                    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
                );
            }
            return false;
        }
    }
};
